type TUpdatedProperties<T> = {
    [Property in keyof T]?: T[Property]
}

export function updateObject<T>(oldObj: T, updatedProperties: TUpdatedProperties<T>): T {
    return {
        ...oldObj,
        ...updatedProperties
    }
}